import type { SxProps, Theme } from '@mui/material'
import { TableBody } from '@mui/material'
import type { ReactNode } from 'react'

interface ISimpleTableBodyProps {
  children: ReactNode
  sx?: SxProps<Theme>
}

export default function SimpleTableBody({ children, sx }: ISimpleTableBodyProps) {
  return <TableBody sx={sx}>{children}</TableBody>
}
